import { Component } from '@jakeklassen/ecs';

export class BallTag extends Component {}
